import LabelOutInput from '@/shared/components/LabelOutInput/LabelOutInput';
import externalUrls from '@/shared/config/externalUrls';
import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';
import { UserData } from '@/types/user';
import { IonItem, IonLabel, IonRouterLink } from '@ionic/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UserDetailForm.module.css';

export const UserDetailForm: React.FC<{ user: UserData }> = ({ user }) => {
  const { firstName, lastName, email } = user;

  const { t } = useTranslation();
  const { isMobileView } = useWindowDimensions();

  const userRecords = [
    {
      label: t('data.firstName'),
      value: firstName
    },
    {
      label: t('data.lastName'),
      value: lastName
    },
    {
      label: t('data.email'),
      value: email
    }
  ];

  return (
    <>
      {userRecords.map(({ label, value }) =>
        isMobileView ? (
          <IonItem className={styles.item} detail={false} key={label} lines={'none'}>
            <IonLabel>{label}</IonLabel>
            <IonLabel class="ion-text-right">{value}</IonLabel>
          </IonItem>
        ) : (
          <div className={styles.input} key={label}>
            <LabelOutInput disabled={true} label={label} name={label} value={value} />
          </div>
        )
      )}
      <div className={`${styles.notes} ${isMobileView ? 'ion-text-center' : ''}`}>
        {t('settings.change_data')}{' '}
        <IonRouterLink
          href={externalUrls.pages.helpInfo.support.url}
          target="_blank"
          color="primary"
          className={isMobileView ? styles.link : ''}
        >
          {t(externalUrls.pages.helpInfo.support.title)}
        </IonRouterLink>
        .
      </div>
    </>
  );
};
